/* CARLINA – galerie produit : defilement a la souris sur ordinateur
   - cliquer-glisser l'image principale vers la gauche / la droite
   - balayage horizontal au trackpad ou molette horizontale
   Les vignettes restent cliquables. Mobile : comportement natif conserve. */
(function(){
  if (window.__clGallery) return;
  window.__clGallery = true;
  var DESKTOP = window.matchMedia('(min-width: 750px)');
  var DRAG_MIN = 45;
  var WHEEL_MIN = 25;
  var WHEEL_LOCK = 450;

  var css = document.createElement('style');
  css.textContent = '@media (min-width:750px){media-gallery .product__media-list{cursor:grab}media-gallery.cl-dragging .product__media-list{cursor:grabbing}media-gallery.cl-dragging{user-select:none;-webkit-user-select:none}media-gallery .product__media-list img{-webkit-user-drag:none}}';
  document.head.appendChild(css);

  function thumbs(gallery){
    return Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item button.thumbnail, .thumbnail-list__item .thumbnail'));
  }
  function go(gallery, dir){
    var list = thumbs(gallery);
    if (list.length < 2) return false;
    var cur = -1;
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('aria-current') === 'true') { cur = i; break; }
    }
    if (cur === -1) {
      var active = gallery.querySelector('.product__media-item.is-active');
      if (active) {
        var id = active.getAttribute('data-media-id');
        for (var j = 0; j < list.length; j++) {
          var li = list[j].closest('[data-target]');
          if (li && li.getAttribute('data-target') === id) { cur = j; break; }
        }
      }
    }
    if (cur === -1) cur = 0;
    var next = (cur + dir + list.length) % list.length;
    list[next].click();
    return true;
  }

  function bind(gallery){
    if (gallery.__clBound) return;
    var area = gallery.querySelector('.product__media-list') || gallery.querySelector('[id^="GallerySlider"]');
    if (!area) return;
    gallery.__clBound = true;

    var startX = 0, startY = 0, down = false, moved = false, lastWheel = 0;

    area.addEventListener('pointerdown', function(e){
      if (!DESKTOP.matches || e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startY = e.clientY;
    });
    window.addEventListener('pointermove', function(e){
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(e.clientY - startY)) {
        moved = true;
        gallery.classList.add('cl-dragging');
      }
    });
    window.addEventListener('pointerup', function(e){
      if (!down) return;
      down = false;
      gallery.classList.remove('cl-dragging');
      var dx = e.clientX - startX;
      if (moved && Math.abs(dx) >= DRAG_MIN) {
        go(gallery, dx < 0 ? 1 : -1);
      }
      if (moved) {
        /* empeche l'ouverture du zoom apres un glisser */
        var block = function(ev){ ev.preventDefault(); ev.stopPropagation(); };
        gallery.addEventListener('click', block, true);
        setTimeout(function(){ gallery.removeEventListener('click', block, true); }, 50);
      }
    });
    area.addEventListener('dragstart', function(e){ if (DESKTOP.matches) e.preventDefault(); });

    area.addEventListener('wheel', function(e){
      if (!DESKTOP.matches) return;
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < WHEEL_MIN) return;
      e.preventDefault();
      var now = Date.now();
      if (now - lastWheel < WHEEL_LOCK) return;
      lastWheel = now;
      go(gallery, e.deltaX > 0 ? 1 : -1);
    }, { passive: false });
  }

  function init(){
    var galleries = document.querySelectorAll('media-gallery');
    for (var i = 0; i < galleries.length; i++) bind(galleries[i]);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  /* re-initialise si la galerie est re-rendue (changement de variante, apercu rapide) */
  new MutationObserver(function(){ init(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
